<template>
  <router-link :to="{ name: name, params: params }" class="has-text-weight-semibold" style="color: rgb(0, 93, 161)">
    <slot></slot>
  </router-link>
</template>
<script>

  export default {
    name: 'link-component',
    props: {
      name: {
        type: String,
        required: true
      },
      params: {
        type: Object,
        required: true
      }
    }
  }
</script>
